import React, {useEffect, useState, useContext} from 'react';
import styled, {ThemeContext} from 'styled-components';
import { Context } from '../Context/ThemeContext';
import useAuth from '../Context/hooks/useAuth';

import Switch from 'react-switch';
import {shade} from 'polished';

import { IconButton } from '@material-ui/core';
import { FiPower } from 'react-icons/fi';

const HeaderContainer =  styled.div`
    display: flex;
    align-items:center;
    padding: .5rem;
    margin-bottom: 20;
    background: ${props => props.theme.colors.primary};
    color: white;
    box-shadow: 1px -2px 9px 0px rgb(0 0 0 / 35%);

    img{
        background: white;
    }

    background-image: url("../../../assets/imagens/impulso-network.svg");
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;

    background-attachment: fixed;

`;

// const imgSprite = 'human';
// const imgSprite = 'bottts';
// const imgSprite = 'initials';
const imgSprite = 'avataaars';


const Header = () => {

    const { user, handleLogout, authenticated} = useAuth();

    const {toggleTheme} = useContext(Context);
    const { colors, title } = useContext(ThemeContext);

	return(
        <HeaderContainer>
            <img width="40px" style={{borderRadius:"50%"}} src={`https://avatars.dicebear.com/4.5/api/${imgSprite}/${user.nome}.svg`}></img>
            <div style={{marginLeft:12, flex:1}}>
                <p style={{margin:'0', fontSize:"90%"}} >{user.nome}</p>		
                <p style={{margin:'0', fontSize:"60%"}}>{user.email}</p>		
            </div>
            <Switch
                onChange={toggleTheme}
                checked={title == 'dark'}
                checkedIcon={false}
                uncheckedIcon={false}
                height={10}
                width={35}
                handleDiameter={20}
                offColor={shade(0.15, colors.primary)}
                onColor={colors.secundary}
            />

            <IconButton className="mx-2" size="small" title="Sair" onClick={handleLogout}>
                <FiPower size={23} color="white"/>
            </IconButton>

        </HeaderContainer>
	)
}

export default Header
